export default __webpack_public_path__ + "static/media/gl_2.e25011fc.mp3";